import React from 'react'
import { yupResolver } from '@hookform/resolvers/yup'

import { useControlledForm, useFormReset } from 'hooks'
import { importCandidateSheet } from 'utils/sheet'
import { getDefaultValues } from './model'
import { getSchema } from './schema'

export const useImportCandidatesForm = (state, handlers) => {
  const { isOpen } = state
  const { onConfirm } = handlers

  const [shouldReset, setShouldReset] = React.useState(false)

  const defaultValues = getDefaultValues()
  const schema = getSchema()

  const handleFormData = React.useCallback(
    async data => {
      try {
        const payload = await importCandidateSheet(data.file ?? [])

        onConfirm(
          { candidates: payload },
          { onSuccess: () => setShouldReset(true) },
        )
      } catch (error) {
        console.log({ error })
      }
    },
    [onConfirm],
  )

  const {
    control,
    formState,
    handleFormReset,
    handleFormSubmit,
    watch,
    isDirtyOrInvalid,
  } = useControlledForm({
    defaultValues,
    resolver: yupResolver(schema),
    handleFormData,
  })

  useFormReset(
    { shouldReset: shouldReset && formState.isSubmitSuccessful },
    handleFormReset,
  )

  React.useEffect(() => {
    if (isOpen) {
      setShouldReset(false)
    }
  }, [isOpen])

  return {
    state: { control, formState, isDirtyOrInvalid },
    handlers: { handleFormReset, handleFormSubmit, watch },
  }
}
